import React, { memo } from 'react';
import useNotificationHandlerWrapper from '@/notifications/components/useNotificationHandlerWrapper';

function RequestNotificationPermission({ children, renderUnsupported }) {
    if (process.env.NODE_ENV !== 'production') {
        if (React.Children.count(children) !== 1) {
            throw Error('SubscribeButton can only have 1 child!');
        }
    }
    const { browserSupported, withRegisteredNotif } = useNotificationHandlerWrapper();

    if (!browserSupported && !renderUnsupported) {
        return null;
    }
    return React.Children.only(
        React.cloneElement(children, {
            onClick: withRegisteredNotif(children.props.onClick)
        })
    );
}

export default memo(RequestNotificationPermission);
